import * as React from 'react'
import Tooltip from 'react-tooltip'
import { LIGHTGREEN } from '../../../../constants/Colors'
import { THEME_COLORS } from '@getgreenline/shared'

interface Props {
  title: string
  description?: string
  tooltip?: string
  checked: boolean
  onClick: () => void
}

export const ModifyReasonCardOCS = ({ title, description, tooltip, checked, onClick }: Props) => {
  return (
    <div
      className='card h-100'
      onClick={() => onClick()}
      style={{ cursor: 'pointer', backgroundColor: checked ? THEME_COLORS.BRAND.black : '' }}
    >
      <div className='card-body d-flex'>
        <div style={{ flexGrow: 1 }}>
          <b className={checked ? 'mr-2 text-white' : 'mr-2'}>{title}</b>
          {!!tooltip && (
            <>
              <span
                data-tip
                data-for={title}
                className='fa fa-info-circle m4-2'
                style={{ cursor: 'pointer' }}
              />
              <Tooltip place='right' id={title} effect='solid'>
                {tooltip}
              </Tooltip>
            </>
          )}
          {!!description && <p className={checked ? 'text-white' : 'text-muted'}>{description}</p>}
        </div>
        <div>
          <span className={'fa fa-check-circle ' + (checked ? 'text-white' : 'text-light')} />
        </div>
      </div>
    </div>
  )
}
